export default {
    messages: {
        "navbar.links.discover": "SCOPRI UBISOFT+",
        "navbar.links.store": "Store",
        "navbar.links.news": "Novità",
        "navbar.links.forum": "Forum",
        "navbar.links.support": "Supporto",
        "navbar.links.status": "Il mio stato",
        "navbar.links.featured": "In evidenza",
        "navbar.links.rewards": "Riscatta",
        "navbar.links.library": "Tutti i giochi",
        "navbar.links.benefits": "Ricompense UBISOFT+",
        "navbar.links.subscription": "Gestisci il mio abbonamento",
        "navbar.links.cloud": "Cloud available",
        "heading.all_games": "Tutti i giochi",
        "heading.my_games": "Continua a giocare",
        "heading.popular_games": "I più giocati",
        "heading.recommended_games": "Consigliati per te",
        "action.load_more_games": "Carica altri giochi",
        "action.search_for_game": "Cerca un gioco",
        "action.launch_game": "Avvia gioco",
        "action.activate_game": "Attiva gioco",
        "filters.brand": "Filtra per brand",
        "filters.game_name": "A - Z",
        "filters.release_date": "Data di uscita",
        "filters.show_all": "Mostra tutto",
        "filters.sort": "Ordina per",
        "filters.all": "Tutto",
        "filters.activated": "Attivati",
        "message.no_activated_games": "Nessun gioco attivato corrisponde alla tua ricerca",
        "message.already_owned": "Possiedi già questo gioco",
        "message.no_available_games": "Nessun gioco disponibile corrisponde alla tua ricerca",
        "message.no_search_results": "Nessun gioco corrisponde alla tua ricerca",
        "message.error": "Si è verificato un errore durante l'elaborazione della richiesta",
        "message.refresh_page": "Clicca qui per riprovare",
        "message.no_subscription": "Non hai un abbonamento attivo",
        "warning.savefiles_alert.title": "Messaggio importante per i file salvati",
        "warning.savefiles_alert.body": "Il passaggio alle edizioni premium disponibili su UBISOFT+ avrà degli effetti sui tuoi file salvati e sui tuoi attuali progressi in-game. Se il tuo abbonamento UBISOFT+ sta per scadere, ti occorre acquistare il Season Pass per caricare tutti i tuoi file salvati (inclusi i tuoi attuali progressi in-game). Per maggiori informazioni ti invitiamo a leggere l'articolo {here}.",
        "warning.savefiles_alert.body.here": "qui",
        "warning.savefiles_alert.cancel": "Indietro",
        "warning.savefiles_alert.confirm": "Conferma",
        "warning.mobile_launch_alert.body": "{game} è stato aggiunto ai tuoi giochi. Lancia Uplay dal tuo PC per giocare.",
        "footer.copyright": "© {year} Ubisoft Entertainment. All Rights Reserved. Ubisoft, Ubi.com and the Ubisoft logo are trademarks of Ubisoft Entertainment in the U.S. and/or other countries",
        "footer.links.ubi_link_label": "ubisoft.com",
        "footer.links.terms_of_use_label": "CONDIZIONI D'USO",
        "footer.links.privacy_policy_label": "TUTELA DELLA PRIVACY",
        "footer.links.legal_label": "NOTE LEGALI",
        "hero.title": "Servizio di Abbonamento Ubisoft",
        "hero.subtitle": "Accesso illimitato a +100 giochi | Disdici in qualsiasi momento",
        "hero.buttons.subscribe": "Abbonati ora",
        "hero.buttons.login": "Accedi",
        "hero.buttons.browse": "Vedi tutti i giochi",
        "progression.benefits.description": "Sblocca i nostri mondi e conquista il tuo. Vogliamo premiare la tua fedeltà! Ottieni nuovi oggetti in-game ogni mese.\r\nPiù stai su Ubisoft+ e più ottieni ricompense in-game da riscattare!",
        "progression.benefit.singular.reward": "oggetto",
        "progression.benefit.plural.reward": "oggetti",
        "progression.benefit.singular.benefit": "Sconto",
        "progression.benefit.plural.benefit": "Sconti",
        "progression.benefit.singular.booster": "booster",
        "progression.benefit.plural.booster": "boosters",
        "progression.level.subscribed_for": "Abbonato UBISOFT+ per",
        "progression.level.new_subscriber": "Nuovo abbonato",
        "progression.level.new_subscribers": "Nuovo abbonati",
        "progression.level.subscription.first_month": "Primo mese",
        "progression.level.subscription.starting_with_months": "{months}+ mesi",
        "general.date.month": "mese",
        "general.date.months": "mesi",
        "general.date.month_remaining": "mese rimanente",
        "general.date.months_remaining": "mesi rimanenti",
        "rewards.monthly_rewards": "Le tue ricompense in-game mensili",
        "rewards.trial_info": "Free trial",
        "rewards.left": "restano {time_left} per riscattare {rewards_left} ricompensa/e questo mese",
        "rewards.current_title": "Ricompense di questo mese",
        "rewards.previous_title": "Ricompense passate",
        "rewards.upcoming_title": "Prossime ricompense",
        "rewards.none_found": "Nessuna ricompensa trovata",
        "rewards.available": "Disponibile",
        "rewards.locked": "Bloccato",
        "rewards.claimed": "Riscattata",
        "rewards.claim": "Si",
        "rewards.cancel": "Annulla",
        "rewards.confirm": "Vuoi riscattare la ricompensa?",
        "rewards.none_left": "Hai riscattato tutte le tue ricompense per questo mese",
        "rewards.already_claimed": "Hai già richiesto questo premio",
        "rewards.claim_confirm": "Questo premio è ora disponibile nel tuo gioco",
        "rewards.close": "Capito!",
        "rewards.load_more": "Carica altro",
        "external.links.actions.go": "Go",
        "external.links.actions.more_info": "Ulteriori informazioni",
        "external.links.actions.learn_more": "Per saperne di più"
    }
};